
import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'

@Component
export default class ToolTipBlueButton extends Vue {
  @Prop() private icon!: string
  @Prop() private text!: string
  @Prop() private readonly disabled!: boolean
  @Prop() private readonly loading!: boolean
  @Prop() private iconSize?: number
  @Prop() private toolTipText!: string
  @Prop() private iconColor?: string
  @Prop() private dataCy?: string
}
